import type { Article } from "@/types/content";

export const articles: Article[] = [
  {
    id: 1,
    slug: "rain-scene-three-days",
    title: "为一场八分钟的雨戏，剧组在棚里等了三整天",
    excerpt:
      "成片里那场雨只下了八分钟，但为了让它下得刚刚好，美术、灯光、雨机与演员在棚里耗了整整三天。这三天里到底在调什么？",
    categorySlug: "onsite",
    categoryName: "拍摄现场",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20studio%20interior%20at%20night%20with%20rain%20machines%20and%20warm%20amber%20work%20lights%20on%20a%20wet%20dark%20stage%20floor%2C%20stylized%20editorial%20photography%2C%20moody%20atmosphere%2C%20no%20people%2C%20high%20detail&width=1280&height=720&seq=hl-rain-hero&orientation=landscape",
    tags: ["雨戏", "棚拍", "现场调度"],
    author: "程知微",
    date: "2026-08-28",
    readTime: "9 分钟",
    views: 48210,
    comments: 316,
    heat: 98,
    featured: true,
    isHot: true,
    content: [
      {
        type: "p",
        text: "成片里那场雨只下了八分钟。但如果你在那三天里走进棚，会发现地上永远积着两厘米深的水，头顶的雨机嗡嗡作响，灯光师正把一盏灯往水里挪第三十几次。",
      },
      {
        type: "h2",
        text: "第一天：先让雨「看得见」",
      },
      {
        type: "p",
        text: "雨戏最难的从来不是下雨，而是让雨在镜头里被看见。水是透明的，逆光下才显形，所以灯光和雨机必须同步调整。第一天的任务几乎全在测光：同一台雨机，灯位差半米，画面里的雨丝密度就完全不同。",
      },
      {
        type: "quote",
        text: "我们不是在下雨，我们是在画雨。",
      },
      {
        type: "h2",
        text: "第二天：让雨「落在对的地方」",
      },
      {
        type: "p",
        text: "雨机喷出的水会顺着舞台坡度流走，主角站立的位置一旦偏移，肩头的湿痕就对不上前一镜。现场剧组用胶带在地上标出站位，再让演员在水里来回走，直到每一处湿痕都能和前一条素材接上。",
      },
      {
        type: "h2",
        text: "第三天：让雨「有情绪」",
      },
      {
        type: "p",
        text: "最后一天才真正开机。为了让雨的大小随台词起伏，场务要给雨机接入手动控制，演员说重音时雨量短暂加大。这样一个几乎没人会注意的细节，反复拍了十几条才过。",
      },
      {
        type: "p",
        text: "等这场戏收工，棚里的水被抽干，地上只剩一圈圈干涸的水痕。八分钟的雨，三天的时间，这就是镜头之外最寻常的日常。",
      },
    ],
  },
  {
    id: 2,
    slug: "variety-guest-first-meeting",
    title: "综艺录制前十五分钟，嘉宾休息室里发生了什么",
    excerpt:
      "观众看到的熟络寒暄，很多是在休息室里用十五分钟临时建立的。导演组、场记和主持人各自需要在这段时间里完成什么？",
    categorySlug: "variety",
    categoryName: "综艺幕后",
    cover:
      "https://readdy.ai/api/search-image?query=Backstage%20green%20room%20in%20a%20television%20variety%20studio%20with%20warm%20amber%20lamp%20light%2C%20simple%20couches%20and%20a%20mirror%2C%20empty%20and%20tidy%2C%20stylized%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-variety-room&orientation=landscape",
    tags: ["录制现场", "嘉宾互动", "综艺"],
    author: "贺云舟",
    date: "2026-08-25",
    readTime: "7 分钟",
    views: 39120,
    comments: 248,
    heat: 93,
    isHot: true,
    content: [
      {
        type: "p",
        text: "一档棚内综艺，正式录制前十到十五分钟，是导演组最紧张的一段时间。这段时间里，休息室的门会被敲开好几次。",
      },
      {
        type: "h2",
        text: "场记先来对流程",
      },
      {
        type: "p",
        text: "场记会拿着流程卡进门，把当天的环节顺序、每个环节预计时长、以及需要嘉宾上台的节点过一次。重点不是流程本身，而是提醒嘉宾哪几个环节允许自由发挥。",
      },
      {
        type: "h2",
        text: "然后是导演组的「破冰」",
      },
      {
        type: "p",
        text: "如果几位嘉宾彼此不熟，导演组会在休息室里先聊几句日常，观察谁和谁接得上话。这些聊天不会录进成片，但直接决定了台本里哪些互动可以放心交给嘉宾自己完成。",
      },
      {
        type: "quote",
        text: "休息室里的十五分钟，往往决定了台上两小时好不好看。",
      },
      {
        type: "p",
        text: "所以观众看到的那些自然到不像演的寒暄，背后其实是有人提前把气氛调到了合适的温度。",
      },
    ],
  },
  {
    id: 3,
    slug: "editing-room-deleted-scene",
    title: "剪辑台删掉的那三分钟，恰好是全片最贵的一场戏",
    excerpt:
      "预告里出现过的镜头，成片里可能一分钟都不剩。剪辑师判断一段戏该不该留，看的往往不是它花了多少钱，而是它让节奏停在了哪里。",
    categorySlug: "editing",
    categoryName: "剪辑台",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20professional%20film%20editing%20suite%20with%20multiple%20monitors%20glowing%20amber%2C%20timeline%20software%20on%20screens%2C%20desk%20with%20keyboard%2C%20stylized%20editorial%20photography%2C%20cinematic%20moody%20lighting%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-edit-room&orientation=landscape",
    tags: ["剪辑", "节奏", "成片"],
    author: "陆听澜",
    date: "2026-08-22",
    readTime: "8 分钟",
    views: 44680,
    comments: 302,
    heat: 95,
    isHot: true,
    content: [
      {
        type: "p",
        text: "有一段戏，拍摄时用了一整天的群演，搭了半个实景，预算表上排在前列。它最终没有出现在成片里。",
      },
      {
        type: "h2",
        text: "剪辑师先问的不是「好不好看」",
      },
      {
        type: "p",
        text: "面对一段素材，剪辑师通常先问三个问题：它在第几分钟、它之前观众在期待什么、它之后故事要往哪儿走。如果这段戏让期待泄了气，再贵也要考虑拿下。",
      },
      {
        type: "h2",
        text: "「最贵」只是它被记住的理由",
      },
      {
        type: "p",
        text: "被删的戏往往会被观众记住，是因为预告片里出现过。可预告要的是瞬间的吸引力，成片要的是两小时的呼吸感，这两件事的评判标准并不相同。",
      },
      {
        type: "quote",
        text: "剪辑不是把拍得好的留下，而是让留下的每一秒都值得。",
      },
      {
        type: "p",
        text: "所以剪辑台前的取舍，很少是关于值不值钱，更多是关于值不值得占用观众的那一分钟。",
      },
    ],
  },
  {
    id: 4,
    slug: "night-shoot-timetable",
    title: "夜戏时间表：从傍晚六点到凌晨四点，片场如何运转",
    excerpt:
      "夜戏不是「把白天挪到晚上」。从布光、收音到夜宵，一张夜戏通告单背后，是整个剧组生物钟的重新排列。",
    categorySlug: "onsite",
    categoryName: "拍摄现场",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20night%20film%20set%20with%20warm%20amber%20floodlights%20and%20cables%20on%20a%20quiet%20street%2C%20light%20stands%20and%20diffusers%2C%20stylized%20editorial%20photography%2C%20deep%20shadows%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-night-shoot&orientation=landscape",
    tags: ["夜戏", "通告单", "现场"],
    author: "程知微",
    date: "2026-08-19",
    readTime: "6 分钟",
    views: 28140,
    comments: 176,
    heat: 84,
    content: [
      {
        type: "p",
        text: "一张夜戏通告单，通常从下午四点开始。这个时间不是随便定的，它要保证布光在天黑前完成。",
      },
      {
        type: "h2",
        text: "六点：布光窗口只剩一小时",
      },
      {
        type: "p",
        text: "天光变化最快的一小时，是夜戏布光最紧张的时候。美术和灯光要先按最终夜景的亮度把基础光铺好，等天黑之后只需微调，而不是从零开始。",
      },
      {
        type: "h2",
        text: "凌晨两点：效率开始下滑",
      },
      {
        type: "p",
        text: "无论剧组多专业，凌晨两点后的效率都会下降。所以通告单会把最复杂的镜头排在晚上十点之前，把简单的过场留到后半夜。",
      },
      {
        type: "quote",
        text: "夜戏拼的不是谁更拼，是谁更会安排。",
      },
      {
        type: "p",
        text: "夜宵、热饮和短暂的十分钟休息，都会被写进通告，这不是福利，而是保证第二天还能继续拍的必要成本。",
      },
    ],
  },
  {
    id: 5,
    slug: "costume-department-detail",
    title: "服化道的一天：一件戏服从量体到首次上身要经过多少手",
    excerpt:
      "一件主要角色的戏服，从确定方案到演员第一次穿上，中间要过多少道工序、多少个人？我们把流程完整走了一遍。",
    categorySlug: "crew",
    categoryName: "剧组江湖",
    cover:
      "https://readdy.ai/api/search-image?query=Costume%20department%20workshop%20with%20fabric%20rolls%2C%20pins%2C%20measuring%20tape%20and%20dress%20forms%2C%20warm%20amber%20daylight%20through%20windows%2C%20stylized%20editorial%20photography%2C%20craft%20texture%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-costume&orientation=landscape",
    tags: ["服化道", "剧组", "筹备"],
    author: "周砚青",
    date: "2026-08-15",
    readTime: "7 分钟",
    views: 22310,
    comments: 141,
    heat: 79,
    content: [
      {
        type: "p",
        text: "在一部作品开拍前，服化道往往是最早进组的部门之一，因为一件主要戏服从方案到上身，快也要两到三周。",
      },
      {
        type: "h2",
        text: "从人物小传到色卡",
      },
      {
        type: "p",
        text: "服装指导先读人物小传，把角色的年龄段、职业、经济状况拆成可执行的视觉线索，再选定一组基础色卡，避免同一场景里两件衣服互相打架。",
      },
      {
        type: "h2",
        text: "量体、立裁、试穿",
      },
      {
        type: "p",
        text: "量体之后先做立裁样衣，让演员穿着走两步、抬抬手，确认剧中的动作幅度不受限制，再进入正式缝制。这个环节经常要反复两三次。",
      },
      {
        type: "quote",
        text: "戏服要好看，但第一标准是演员穿着能演戏。",
      },
      {
        type: "p",
        text: "所以一件戏服最终上身时，幕后已经有量体师、立裁师、缝纫、染色与跟组服装在场，每一双手都在为同一个镜头服务。",
      },
    ],
  },
  {
    id: 6,
    slug: "variety-game-rule-rehearsal",
    title: "游戏环节为什么要提前彩排三遍，导演在防什么",
    excerpt:
      "一个看起来随手就能玩的游戏，为什么录制前要空场彩排三次？答案藏在安全、时长和意外这三个词里。",
    categorySlug: "variety",
    categoryName: "综艺幕后",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20colorful%20variety%20show%20game%20set%20with%20wooden%20props%20and%20markers%20on%20the%20floor%2C%20warm%20amber%20studio%20lights%2C%20stylized%20editorial%20photography%2C%20playful%20but%20tidy%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-variety-game&orientation=landscape",
    tags: ["游戏环节", "彩排", "安全"],
    author: "贺云舟",
    date: "2026-08-12",
    readTime: "6 分钟",
    views: 19870,
    comments: 118,
    heat: 76,
    content: [
      {
        type: "p",
        text: "观众看到的是嘉宾临时被规则难住，但在这之前，同一个游戏可能已经被工作人员空场玩过三遍。",
      },
      {
        type: "h2",
        text: "第一遍：测时长",
      },
      {
        type: "p",
        text: "导演组先让工作人员按正常速度玩一遍，记录真实耗时。如果一个环节光玩就要二十分钟，成片里根本放不下，规则必须提前简化。",
      },
      {
        type: "h2",
        text: "第二遍：找漏洞",
      },
      {
        type: "p",
        text: "任何规则都有被钻空子的方式。彩排的目的之一，就是提前找到那些会让游戏失去悬念的捷径，并在规则里堵上。",
      },
      {
        type: "quote",
        text: "彩排不是为了让嘉宾玩得顺，是为了让游戏到最后一秒还有悬念。",
      },
      {
        type: "p",
        text: "第三遍则侧重安全与道具损耗，确认场地边缘、道具承重都没问题。三遍下来，一个几分钟的环节才算真正成立。",
      },
    ],
  },
  {
    id: 7,
    slug: "crowd-scene-control",
    title: "两百人群戏：现场副导演是如何让所有人一秒安静的",
    excerpt:
      "两百人的广场，嘈杂得像菜市场。副导演喊一声，全场瞬间安静。这套让数百人同步的方法，其实是流程而不是嗓门。",
    categorySlug: "onsite",
    categoryName: "拍摄现场",
    cover:
      "https://readdy.ai/api/search-image?query=Wide%20open%20outdoor%20plaza%20film%20set%20at%20dusk%20with%20lighting%20stands%20and%20marked%20floor%20positions%2C%20warm%20amber%20glow%2C%20stylized%20editorial%20photography%2C%20orderly%20and%20calm%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-crowd&orientation=landscape",
    tags: ["群戏", "调度", "副导演"],
    author: "程知微",
    date: "2026-08-08",
    readTime: "7 分钟",
    views: 25690,
    comments: 153,
    heat: 81,
    content: [
      {
        type: "p",
        text: "两百人的群戏，现场最怕的不是拍不好，而是没人听见指令。所以关键从来不是喊得多大声，而是让流程本身能被看见。",
      },
      {
        type: "h2",
        text: "把人群先分组",
      },
      {
        type: "p",
        text: "开机前，现场副导演会把群演按区域分成若干组，每组指定一名小组长。指令先传到小组长，再由他们手势传下去，比一个人喊全场快得多。",
      },
      {
        type: "h2",
        text: "用灯光代替喊话",
      },
      {
        type: "p",
        text: "正式拍摄时，现场的「安静」往往由灯光变化触发。主灯调暗的瞬间，就是全组准备的信号，这个约定在开机前就通知到每个人。",
      },
      {
        type: "quote",
        text: "让人觉得被安排得明白，比让人觉得被管住更重要。",
      },
      {
        type: "p",
        text: "一条群戏能顺利过，靠的是这些提前约定好的细节，而不是现场某一次突然的发威。",
      },
    ],
  },
  {
    id: 8,
    slug: "film-readthrough-notes",
    title: "围读会实录：剧本里没写的那场争吵是怎么冒出来的",
    excerpt:
      "围读会不只是念台词。当导演、演员和编剧坐在一张桌子前，剧本里藏着的裂缝会第一时间暴露出来。",
    categorySlug: "film",
    categoryName: "影视探班",
    cover:
      "https://readdy.ai/api/search-image?query=Long%20wooden%20conference%20table%20with%20script%20pages%20and%20coffee%20cups%2C%20warm%20amber%20indoor%20lamp%20light%2C%20quiet%20reading%20room%2C%20stylized%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-readthrough&orientation=landscape",
    tags: ["围读", "剧本", "主创"],
    author: "林砚白",
    date: "2026-08-05",
    readTime: "8 分钟",
    views: 21040,
    comments: 129,
    heat: 78,
    content: [
      {
        type: "p",
        text: "围读会通常在开机前一到两周举行。一张长桌，主创各坐一边，从第一场戏开始念。",
      },
      {
        type: "h2",
        text: "念到第三场，问题就出来了",
      },
      {
        type: "p",
        text: "台词读出口的一瞬间，哪些地方不合人物、哪些地方演员接不上情绪，会立刻显形。编剧当场记下，导演当场和演员确认调整方向。",
      },
      {
        type: "h2",
        text: "争吵其实是被欢迎的",
      },
      {
        type: "p",
        text: "如果一场戏让两位角色本该有矛盾却全程客气，围读时一定有人提出异议。这种讨论往往持续很久，但正是它让后面几场戏变得更可信。",
      },
      {
        type: "quote",
        text: "剧本是在桌子前被读顺的，不是在片场被赶出来的。",
      },
      {
        type: "p",
        text: "等到围读结束，剧本往往已经改过一轮。这些修改不会写在片尾字幕里，却决定了成片里每一句台词的重量。",
      },
    ],
  },
  {
    id: 9,
    slug: "backstage-live-mishap",
    title: "直播晚会的一次临场救场，导播间只有八秒做决定",
    excerpt:
      "台上一切如常，导播间里已经炸开了。当一个环节比计划提前结束，八秒钟内要完成的判断，决定了晚会是否穿帮。",
    categorySlug: "backstage",
    categoryName: "幕后故事",
    cover:
      "https://readdy.ai/api/search-image?query=Television%20broadcast%20control%20room%20with%20wall%20of%20monitors%20glowing%20amber%2C%20mixing%20console%20and%20switcher%2C%20cinematic%20moody%20lighting%2C%20stylized%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-control-room&orientation=landscape",
    tags: ["直播", "导播", "救场"],
    author: "苏未迟",
    date: "2026-08-01",
    readTime: "7 分钟",
    views: 33470,
    comments: 214,
    heat: 90,
    isHot: true,
    content: [
      {
        type: "p",
        text: "一场直播晚会，某个语言类节目比彩排时短了四十秒。台上没人察觉，导播间里的时钟却在飞快倒计时。",
      },
      {
        type: "h2",
        text: "八秒窗口",
      },
      {
        type: "p",
        text: "从发现时长缺口，到必须切出下一个画面，中间只有大约八秒。这八秒里，导播要判断：是拉长台上的互动，还是提前进广告，还是调到备播短片。",
      },
      {
        type: "h2",
        text: "备播素材为什么永远待命",
      },
      {
        type: "p",
        text: "成熟的晚会都会准备若干条与主题相关的备播短片，长度各不相同。它们的价值不在于好看，而在于能被精确地塞进任何时长的缺口里。",
      },
      {
        type: "quote",
        text: "直播的从容，是提前把每一种意外都预演过。",
      },
      {
        type: "p",
        text: "最后导播选择让主持人多聊一句现场氛围，恰好补上四十秒。这段内容既不在台本里，也不在彩排中，只在那一晚的八秒判断里。",
      },
    ],
  },
  {
    id: 10,
    slug: "catering-on-set",
    title: "剧组盒饭江湖：一天四餐，生活制片怎么排这盘棋",
    excerpt:
      "一个两三百人的剧组，每天要消耗多少份餐食？从订餐、分餐到特殊饮食，生活制片的工作远比想象中复杂。",
    categorySlug: "crew",
    categoryName: "剧组江湖",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20film%20set%20catering%20station%20with%20stacked%20meal%20boxes%20and%20thermos%20containers%20on%20folding%20tables%2C%20warm%20amber%20afternoon%20light%2C%20stylized%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-catering&orientation=landscape",
    tags: ["生活制片", "剧组", "后勤"],
    author: "周砚青",
    date: "2026-07-28",
    readTime: "6 分钟",
    views: 17260,
    comments: 96,
    heat: 71,
    content: [
      {
        type: "p",
        text: "剧组吃饭从来不是小事。一个三百人的组，一天四餐，订餐稍有闪失，整个下午的进度都会受影响。",
      },
      {
        type: "h2",
        text: "四餐分别对应什么",
      },
      {
        type: "p",
        text: "早餐、午餐、下午茶与夜宵各有作用。下午茶尤其关键，通常在连续工作几小时后发放，用来抵消注意力的下滑，而不是单纯的福利。",
      },
      {
        type: "h2",
        text: "特殊饮食要单独记",
      },
      {
        type: "p",
        text: "组里可能有素食、忌口或宗教饮食习惯的成员，这些都会在进组时登记，由生活制片单独列单，避免本人到了发餐点才发现没有可吃的。",
      },
      {
        type: "quote",
        text: "把饭安排明白，是让整个组专心拍戏的前提。",
      },
      {
        type: "p",
        text: "所以别小看那一盒饭，它背后是一张精确到分钟的后勤时间表。",
      },
    ],
  },
  {
    id: 11,
    slug: "editing-rhythm-trick",
    title: "同一个镜头换三种顺序，情绪为什么要靠剪辑重排",
    excerpt:
      "同样的三个镜头，换个先后顺序，观众感受到的情绪可能完全相反。剪辑的顺序感，是幕后最容易被忽略的创作。",
    categorySlug: "editing",
    categoryName: "剪辑台",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20video%20editing%20timeline%20on%20a%20wide%20monitor%20with%20amber%20waveforms%2C%20dark%20studio%20desk%2C%20cinematic%20moody%20lighting%2C%20stylized%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-rhythm&orientation=landscape",
    tags: ["剪辑节奏", "镜头", "情绪"],
    author: "陆听澜",
    date: "2026-07-24",
    readTime: "7 分钟",
    views: 23980,
    comments: 137,
    heat: 80,
    content: [
      {
        type: "p",
        text: "给剪辑师三个镜头：一个人推门、一个人抬头、一个人握紧了手。把它们按不同顺序排，观众读到的故事就完全不同。",
      },
      {
        type: "h2",
        text: "顺序决定因果",
      },
      {
        type: "p",
        text: "先给握紧的手，再给推门，观众会认为有人在等待；先给推门，再给握紧的手，观众会认为有人在紧张。画面没变，因果被重排了。",
      },
      {
        type: "h2",
        text: "停顿也是语言",
      },
      {
        type: "p",
        text: "镜头之间多留两帧，情绪会变得迟疑；缩短两帧，节奏会立刻变急。剪辑师常常为这两帧反复试片，直到观感刚好。",
      },
      {
        type: "quote",
        text: "剪辑不创造画面，它创造观众的感受顺序。",
      },
      {
        type: "p",
        text: "这也是为什么幕后素材里同一组镜头会有多个版本，最终能留下一个，都是被剪掉的那些换来的。",
      },
    ],
  },
  {
    id: 12,
    slug: "variety-camera-count",
    title: "一档棚内综艺用了几十个机位，画面是怎么被挑出来的",
    excerpt:
      "现场几十路画面同时回传，导播要在几秒内决定观众看到哪一路。这背后是一套被称为「切换」的现场判断。",
    categorySlug: "variety",
    categoryName: "综艺幕后",
    cover:
      "https://readdy.ai/api/search-image?query=Row%20of%20professional%20television%20cameras%20on%20tripods%20facing%20a%20colorful%20empty%20studio%20stage%2C%20warm%20amber%20lights%2C%20stylized%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-camera-count&orientation=landscape",
    tags: ["机位", "导播", "棚录"],
    author: "贺云舟",
    date: "2026-07-20",
    readTime: "6 分钟",
    views: 18430,
    comments: 104,
    heat: 73,
    content: [
      {
        type: "p",
        text: "走进一档棚内综艺的录制现场，最先注意到的一定是机位的数量。主舞台、观众席、侧机位、游机，加起来几十台。",
      },
      {
        type: "h2",
        text: "每一路都有明确分工",
      },
      {
        type: "p",
        text: "主机位负责全景与稳定叙事，侧机位抓反应，游机负责近距离细节。导播台上的监视器墙上，每一路画面都贴着对应的编号和职责。",
      },
      {
        type: "h2",
        text: "切换是一瞬间的判断",
      },
      {
        type: "p",
        text: "当嘉宾说出一句意外的话时，导播会立刻切到最能反映现场情绪的那一路。这个判断通常只有一两秒，靠的是提前记住每个机位此刻在拍什么。",
      },
      {
        type: "quote",
        text: "观众看到的那一路，是几十路里被当场选中的那一路。",
      },
      {
        type: "p",
        text: "所以一档节目好不好看，不只取决于台上发生了什么，也取决于每一次切换有没有选对。",
      },
    ],
  },
  {
    id: 13,
    slug: "film-location-scout",
    title: "选景笔记：为什么导演最后放弃了那个更漂亮的取景地",
    excerpt:
      "一个光看照片就让人心动的取景地，最终却输给了一处更朴素的地方。选景考量的从来不只是美不美。",
    categorySlug: "film",
    categoryName: "影视探班",
    cover:
      "https://readdy.ai/api/search-image?query=Scenic%20empty%20countryside%20location%20with%20old%20stone%20walls%20and%20warm%20amber%20sunset%20light%2C%20distant%20hills%2C%20stylized%20editorial%20photography%2C%20calm%20golden%20tone%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-location&orientation=landscape",
    tags: ["选景", "美术", "筹备"],
    author: "林砚白",
    date: "2026-07-16",
    readTime: "7 分钟",
    views: 15980,
    comments: 88,
    heat: 69,
    content: [
      {
        type: "p",
        text: "选景阶段，导演和美术会看几十处备选。有一处几乎所有人都喜欢：光线好、构图美、照片一眼就能用。",
      },
      {
        type: "h2",
        text: "但它输给了水电",
      },
      {
        type: "p",
        text: "那个地方车辆到不了，发电车和器材要靠人力往上搬。对一场需要大量灯光的戏来说，这意味着每天要多花几个小时在运输上。",
      },
      {
        type: "h2",
        text: "漂亮是加分项，不是决定项",
      },
      {
        type: "p",
        text: "选景真正要权衡的是：能不能按时收工、演员有没有地方待、收音会不会被环境噪音毁掉。这些条件不满足，再美的景也只能放弃。",
      },
      {
        type: "quote",
        text: "能拍完的景，才是好景。",
      },
      {
        type: "p",
        text: "最终剧组选了一处更朴素、但交通和供电都方便的地方，再用美术把它做成了想要的样子。",
      },
    ],
  },
  {
    id: 14,
    slug: "backstage-rain-machine",
    title: "雨机、风机与鼓点：一场情绪戏的现场声音是怎么造的",
    excerpt:
      "很多观众以为情绪戏的紧张感来自配乐，其实在片场，是风机、雨机与现场鼓点在帮演员进入状态。",
    categorySlug: "backstage",
    categoryName: "幕后故事",
    cover:
      "https://readdy.ai/api/search-image?query=Film%20set%20sound%20department%20equipment%20with%20wind%20machine%20rain%20rig%20and%20boom%20microphone%20on%20a%20dark%20stage%2C%20warm%20amber%20accent%20light%2C%20stylized%20editorial%20photography%2C%20no%20people%2C%20high%20detail&width=800&height=500&seq=hl-sound&orientation=landscape",
    tags: ["现场收音", "氛围", "幕后"],
    author: "苏未迟",
    date: "2026-07-12",
    readTime: "6 分钟",
    views: 14230,
    comments: 79,
    heat: 66,
    content: [
      {
        type: "p",
        text: "一场情绪戏开拍前，现场安静得能听见空调声。然后，有人开始轻轻敲鼓。",
      },
      {
        type: "h2",
        text: "声音先于表演",
      },
      {
        type: "p",
        text: "在一些高强度的情绪戏里，导演会让现场部门用风机、雨机或简单的节奏制造环境声。它不进入成片，只为了让演员的身体更早进入状态。",
      },
      {
        type: "h2",
        text: "成片里的声音是重做的",
      },
      {
        type: "p",
        text: "由于现场收音会带上大量杂音，成片中的环境音大多在后期重新制作。但现场那层「氛围声」依然重要，它影响的是表演，而不是最终音轨。",
      },
      {
        type: "quote",
        text: "有些声音是为了被听见，有些声音是为了被进入。",
      },
      {
        type: "p",
        text: "演员给出的那一条最好的表演，往往就和现场这层看不见的声音有关。",
      },
    ],
  },
];